import React from 'react';
import MainNavBar from '../navbar/MainNavBar';
import { Box, Container } from '@mui/material';

const MainLayout = ({ children }) => {

    return (

        <>

            <MainNavBar />

            <Box component="main" sx={{ mt: 2 }}>
                <Container>
                    {children}
                </Container>
            </Box>

        </>

    )

}

export default MainLayout